import { render, staticRenderFns } from "./BundleContacts.vue?vue&type=template&id=39971ac9&"
import script from "./BundleContacts.vue?vue&type=script&lang=js&"
export * from "./BundleContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports